import './ui.css';

interface FormErrorProps {
  message?: string | null;
  id?: string;
  /** `banner` for submit/server failures above a form; `field` (default) below an input. */
  variant?: 'field' | 'banner';
}

/**
 * The single way this app renders an error message. Renders nothing when there
 * is no message, and already carries role="alert" plus the alert icon.
 */
export function FormError({ message, id, variant = 'field' }: FormErrorProps) {
  if (!message) {
    return null;
  }

  return (
    <p
      id={id}
      role="alert"
      className={`ui-form-error${variant === 'banner' ? ' ui-form-error--banner' : ''}`}>
      <svg
        className="ui-form-error__icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
        focusable="false">
        <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 4.5v4.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="8" cy="11.2" r="0.9" fill="currentColor" />
      </svg>
      <span>{message}</span>
    </p>
  );
}
